import styled from '@emotion/styled';
import Button from 'antd/es/button';
import React from 'react';
import { useTranslate } from '@tolgee/react';
import { StoreInfo } from 'services/api/store';

interface Props {
  selected: StoreInfo[];
  onSubmit?: (lsit: StoreInfo[]) => void;
}

const Container = styled.div`
  display: flex;
  justify-content: flex-end;
  align-items: center;
  padding: 8px 6px;
  gap: 12px;
  height: 48px;
  background: var(--fett-bg-elevated);
  border-radius: 0 0 4px 4px;
  border: 0;
  border-top: 1px solid var(--fett-border-default);
  .tips {
    font-size: 14px;
    align-self: center;
    color: var(--fett-text-quaternary);
  }
  button {
    font-size: 14px;
    height: 32px;
    line-height: 32px;
    padding: 0 24px;
  }
`;

const StoreListFooter = React.memo((props: Props) => {
  const { selected, onSubmit } = props;
  const { t } = useTranslate();
  if (!selected.length) {
    return null;
  }
  return (
    <Container>
      <span className="tips">{t('storeSelector.已选{x}', { x: selected.length })}</span>
      <Button type="primary" onClick={() => onSubmit?.(selected)}>
        {t('storeSelector.确认切换')}
      </Button>
    </Container>
  );
});

export default StoreListFooter;
